import React from "react";

import { SubHeading } from "../../components";
import useInView from "../../hooks/useInView";
import "./FindUs.css";

const DOORDASH_URL =
  "https://www.doordash.com/store/pho-ha-long-san-antonio-41685551/103535348/?aw=hEV_jbHuzoPHt7HK";

const FindUs = () => {
  const address = "6424 Northwest Loop 410 #104, San Antonio, TX 78238";
  const encodedAddress = encodeURIComponent(address);
  const mapUrl = `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;
  const mapEmbedUrl = `https://maps.google.com/maps?q=${encodedAddress}&t=&z=15&ie=UTF8&iwloc=&output=embed`;

  const [infoRef, infoVisible] = useInView();
  const [mapRef, mapVisible] = useInView();

  return (
    <div className="app__findus app__wrapper section__padding" id="contact">
      <div
        ref={infoRef}
        className={`app__wrapper_info fade-in-section ${infoVisible ? "visible" : ""}`}
      >
        <SubHeading title="Contact" />
        <h1 className="headtext__cormorant" style={{ marginBottom: "2rem" }}>
          Find Us
        </h1>
        <div className="app__wrapper-content">
          <p className="p__opensans">{address}</p>
          <p className="p__opensans">
            Phone:{" "}
            <a
              href="tel:+12103547547"
              style={{ color: "#DCCA87", textDecoration: "underline" }}
            >
              (210) 354-7547
            </a>
          </p>
          <p
            className="p__cormorant"
            style={{ color: "#DCCA87", margin: "2rem 0" }}
          >
            Opening Hours
          </p>
          <p className="p__opensans">Tuesday - Sunday, Open 6 Days A Week</p>
          <p className="p__opensans">11AM - 8PM</p>
        </div>
        <div className="app__findus-buttons">
          <a
            href={mapUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="custom__button"
          >
            Visit Us
          </a>
          <a
            href={DOORDASH_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="custom__button custom__button--outline"
          >
            Order Delivery
          </a>
        </div>
      </div>

      <div
        ref={mapRef}
        className={`app__wrapper_img fade-in-section fade-in-right ${mapVisible ? "visible" : ""}`}
      >
        <div className="app__findus-map">
          <iframe
            title="Pho Ha Long Location"
            src={mapEmbedUrl}
            width="100%"
            height="400"
            style={{ border: 0, borderRadius: "8px" }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </div>
    </div>
  );
};

export default FindUs;
